
export const API_SITE_CORPO = {


  PAGE: "/pages",
  LANGUAGE: "/languages",
  TRANSLATION: "/translation",
  BLOGS: "/categories",
  BLOGSLIST2: "/categoriesList",
  PROJECTS: "/projects",
  POSTS: "/posts",
  LIST_BLOGS: "/categories-data",
  MENU: "/menu",
  MEDIA: "/media-photo",
  MEDIA_PAGE: "/media-photo/all/images",
  MEDIAUPLOAD: "/media-photo/media",
  MEDIADELETED: "/media-photo/delete-media/",
  FOOTER: "/footer",
  getcategoriesbypost: "/categories-by-post",
  TAGS: "/tags",
  LIST_TAGS: "/tags-data",
  gettagbyactualite: "tags-by-actualites",
  ACTUALITE: "actualites",
  TAGS_NEWS: "/cat-news",
  SHARE: "/post-news",
  LIST_TAGS_NEWS: "/categories-options",
  CVBYUID: "/cvs/uid/",
  CVGETFILE: "/cvs/get_file",
  PATCHCV: "/cvs/byuid/",
  POSTPDF: "/cvs/upload_cv-pdf/",
  ADDCV: "/users/create-user-with-cv",
  JOBS_LIST: "/jobs/get-last-job",  
  VIDEO_UPLOAD: "/videos",  
  CV_UPLOAD: "/cvs",  
  RECRUITING:"/cvs",
  LOGIN: "/auth/login",
  ME: "/me",
  USER:'/auth',
  NEWS_LETTER: '/newsLetter',
  RH_LIVE:'/jobs/where/candidate?publishStatus=public&status=Active',
  NEWS_LETTER_REGISTER: "/newsLetterRegister",
  NEWS_LETTER_LOGIN: "/newsLetterLogin",
  SEND_MAIL: '/subscribe',
  CHART_DATA : "/chart-data",
  CHART_DATA_NEWS : "/categories/posts",
  CHART_DATA_CVS : "/data-by-year",
  CAT_BY_PRESS: "/press-categories-by-post",
  LIST_PRESS_CAT: "/press-categories-data",
  PRESS: "/pressnews",
  PRESSCAT: "/presscategories",

};

